// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'twitter';

export const Component = () => (
  <path
    fill='currentColor'
    d='M38.653 6H45.4L30.66 22.944 48 46H34.422L23.788 32.016 11.62 46H4.869l15.766-18.123L4 6h13.922l9.613 12.781zm-2.368 35.938h3.738L15.891 9.848h-4.012z'
  />
);

export const viewBox = '0 0 50 50';
